import axios from 'axios';
import {
  disconnectWallet
} from '@/plugins/wagmi/connect';
import { useStorage } from '@/composables/use-storage.js'

const { userAuthToken, clearUserData } = useStorage();

// Set the base URL with /api prefix
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:3000';
axios.defaults.withCredentials = true;

// Set upload limits to 4MB
axios.defaults.maxContentLength = 4 * 1024 * 1024; // 4MB
axios.defaults.maxBodyLength = 4 * 1024 * 1024; // 4MB

// Add request interceptor for debugging
axios.interceptors.request.use(request => {

  
  // Add CORS headers
  const token = localStorage.getItem('authToken');
  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`;
  }
  
  if (request.responseType !== 'blob') {
    request.headers['Accept'] = 'application/json';
    request.headers['Content-Type'] = 'application/json';
  }

  if (request.headers['Content-Type'] === 'multipart/form-data') {
    request.headers['Content-Type'] = 'multipart/form-data';
  }
  
  return request;
});

// Add response interceptor for debugging
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('API Error:', {
      message: error.message ?? error.response?.data?.message,
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url,
      method: error.config?.method
    });

    // Check for 503 or 401 status and redirect
    if (error.response?.status === 503) {
     window.location.href = '/status/503';
    } else if (error.response?.status === 401) {
      const hadSession = !!(localStorage.getItem('userInfos') || localStorage.getItem('authToken'));
      if (!hadSession) {
        return Promise.reject(error instanceof Error ? error : new Error(error.message || 'Network Error'));
      }
      try {
        clearUserData();
        disconnectWallet();
        const logoutResponse = axios.post('/api/logout', {}, {
          headers: {
            'Authorization': `Bearer ${userAuthToken.value}`
          }
        });
        console.log(logoutResponse);
        if (!logoutResponse.error) {
          window.location.href = '/login';
          return;
        }
      } catch (logoutError) {
        console.error("Error during logout process:", logoutError);
        return;
      }
    }

    return Promise.reject(error instanceof Error ? error : new Error(error.message || 'Network Error'));
  }
);

export default axios;